module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-map"
  }, [_c('ul', {
    staticClass: "m-map__options list-unstyled"
  }, [_c('li', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "checked"
    },
    on: {
      "click": _vm.updateParksMarkers
    }
  }), _vm._v(" " + _vm._s(_vm.$t('content.tecnoparks')) + "\n          ")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.updateCompaniesMarkers
    }
  }), _vm._v(" " + _vm._s(_vm.$t('commons.companies')) + "\n          ")])])])]), _vm._v(" "), _c('center', [_c('gmap-map', {
    ref: "map",
    style: (_vm.style),
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom,
      "map-type-id": "terrain",
      "bounds": _vm.bounds,
      "options": _vm.options
    }
  }, [_vm._l((_vm.markers), function(institution) {
    return _vm._l((institution.positions), function(p, index) {
      return _c('gmap-marker', {
        key: index,
        attrs: {
          "position": p,
          "clickable": false,
          "draggable": false,
          "icon": _vm.getMarkerIcon(institution.color)
        },
        on: {
          "click": function($event) {
            _vm.center = _vm.m.position
          }
        }
      })
    })
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2702c22a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/Map.vue
// module id = 650
// module chunks = 1